export default __webpack_public_path__ + "static/bangladesh-results-1-4ded604cc3162a676e86e1b50082accf.png";